export const GRABAI_AGENT_ID = 'agent_01jzshmm69f04aa372j0ypyr9t';
export const GRABAI_AGENT_NAME = 'Maya';
export const GRABAI_AVATAR = '/images/grab-ai-avatar.png';

export const QUICK_REPLIES = [
  { id: 'order-status', text: '📦 Where is my order?', value: 'order_status' },
  { id: 'payment-issue', text: '💳 Payment issue', value: 'payment_issue' },
  { id: 'talk-human', text: '🙋 Talk to a human', value: 'talk_human' },
  { id: 'bad-driver', text: '🛵 I had a bad driver', value: 'bad_driver' },
];

export const MOCK_ORDER_DATA = {
  orderId: 'GF-2024-0312-1547',
  restaurant: 'KFC - Bonifacio High Street',
  items: ['2x Zinger Burger', '1x Regular Fries', '2x Pepsi'],
  total: '₱520.00',
  status: 'on_the_way',
  driver: {
    name: 'Juan dela Cruz',
    rating: 4.8,
    phone: '+63 917 XXX XXXX',
    vehicle: 'Honda Click 125i',
    plateNumber: 'ABC 123',
  },
  estimatedArrival: '10 minutes',
  deliveryAddress: 'Tower 2, Unit 1502, BGC',
};

export const CHAT_SCENARIOS = {
  order_status: {
    responses: [
      {
        text: `I found your order! Here's the latest update:\n\n🍔 Order #${MOCK_ORDER_DATA.orderId}\n📍 From: ${MOCK_ORDER_DATA.restaurant}\n🛵 Driver: ${MOCK_ORDER_DATA.driver.name} (${MOCK_ORDER_DATA.driver.rating}⭐)\n⏱️ ETA: ${MOCK_ORDER_DATA.estimatedArrival}\n\nYour food is on the way and should arrive soon! 🎉`,
        followUpActions: [
          { text: '📞 Contact driver', value: 'contact_driver' },
          { text: '❌ Cancel order', value: 'cancel_order' },
          { text: '⚠️ Report an issue', value: 'report_issue' },
        ],
      },
    ],
  },
  payment_issue: {
    responses: [
      {
        text: "I'll help you with your payment issue. Let me check your recent transactions...",
        delay: 1500,
      },
      {
        text: "I see you have a pending refund of ₱120 from your order on March 10. This refund is currently being processed and should reflect in your GCash account within 24-48 hours.",
        followUpActions: [
          { text: '❓ Still have an issue', value: 'payment_still_issue' },
          { text: '🏦 Contact my bank', value: 'contact_bank' },
          { text: '✅ That helps, thanks!', value: 'resolved' },
        ],
      },
    ],
  },
  bad_driver: {
    responses: [
      {
        text: "I'm really sorry to hear you had a bad experience with your driver. Your safety and comfort are our top priorities. 🙏",
        delay: 1000,
      },
      {
        text: "I'd like to help you report this issue. Can you tell me what happened?",
        followUpActions: [
          { text: '😤 Driver was rude', value: 'driver_rude' },
          { text: '🚗 Unsafe driving', value: 'unsafe_driving' },
          { text: '📦 Damaged my order', value: 'damaged_order' },
          { text: '🚫 Other issue', value: 'other_issue' },
        ],
      },
    ],
  },
  talk_human: {
    responses: [
      {
        text: "I understand you'd prefer to speak with a human agent. Let me check the current wait times for you...",
        delay: 2000,
      },
      {
        text: "Good news! I can connect you with a live agent. Current wait time is approximately 2 minutes. Would you like me to transfer you now?",
        followUpActions: [
          { text: '✅ Yes, transfer me', value: 'transfer_yes' },
          { text: '❌ No, I\'ll wait', value: 'transfer_no' },
        ],
      },
    ],
  },
  driver_rude: {
    responses: [
      {
        text: "I'm very sorry to hear that. This behavior is unacceptable. I'm documenting this incident now.",
        delay: 1000,
      },
      {
        text: `I've recorded your complaint about driver ${MOCK_ORDER_DATA.driver.name} for order #${MOCK_ORDER_DATA.orderId}. Our team will review this within 24 hours and take appropriate action.\n\nAs an apology, I've added a ₱50 voucher to your account for your next order.`,
        followUpActions: [
          { text: '🎫 View voucher', value: 'view_voucher' },
          { text: '✅ Thank you', value: 'resolved' },
        ],
      },
    ],
  },
};

export const GRAB_COLORS = {
  primary: '#00B14F',
  secondary: '#1F1F1F',
  accent: '#FFA500',
  background: '#F5F5F5',
  error: '#FF3B30',
  success: '#00B14F',
  warning: '#FFA500',
  info: '#007AFF',
};